//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.Optional
import kotlin.Int
import kotlin.collections.List

public data class GetInspectionListQueryInput(
  public val page: Int,
  public val pageSize: Int,
  public val status: Optional<List<InspectionStatus>?> = Optional.Absent,
)
